import { render, staticRenderFns } from "./EditShipmentAclModal.vue?vue&type=template&id=30c9c865&scoped=true&"
import script from "./EditShipmentAclModal.vue?vue&type=script&lang=js&"
export * from "./EditShipmentAclModal.vue?vue&type=script&lang=js&"
import style0 from "./EditShipmentAclModal.vue?vue&type=style&index=0&id=30c9c865&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c9c865",
  null
  
)

export default component.exports